export const SAENGGIBU_BATCH_PATH = '/batch-saenggibu';
export const SAENGGIBU_UPGRADE_PATH = '/subscription';

export const canShowSaenggibuSuggestionCard = ({
  recordId,
  isGenerating = false,
  isAnonymous = false,
  suggestion = null,
} = {}) => (
  Boolean(recordId)
  && !isGenerating
  && !isAnonymous
  && Boolean(suggestion)
);

export const resolveSaenggibuSuggestionRecordId = (source, { isBatch = false } = {}) => {
  if (!source) return null;
  if (typeof source === 'string' && source.trim()) return source.trim();
  const recordId = source.record_id || source.recordId || null;
  if (recordId) return recordId;
  if (!isBatch) return null;
  return source.job_id || source.generation_job_id || null;
};

export const formatSaenggibuUsageHours = (savedMinutes) => {
  const hours = Math.round(((Number(savedMinutes) || 0) / 60) * 10) / 10;
  return String(hours).replace(/\.0$/, '');
};

export const formatSaenggibuUsageLine = (summary = {}) => {
  const {
    enabled,
    month_records: monthRecords,
    saved_minutes: savedMinutes,
    style_applied_count: styleAppliedCount,
    is_pro: isPro,
    hasProfile,
  } = summary || {};
  const records = Number(monthRecords);
  if (!enabled || !Number.isFinite(records) || records < 3) return '';
  const hours = formatSaenggibuUsageHours(savedMinutes);
  let line = `이번 달 ${records}건 · 약 ${hours}시간 절약했어요`;
  if (isPro && hasProfile) {
    line += ` · 내 스타일 적용 ${Number(styleAppliedCount) || 0}건`;
  }
  return line;
};

export const getSaenggibuSuggestionFingerprint = (suggestion) => (
  suggestion?.payload?.fingerprint || suggestion?.fingerprint || ''
);

export const runSaenggibuSuggestionAction = async ({
  action,
  suggestion,
  act,
  dismiss,
  option,
  text,
  showToast,
  navigate,
  openBatch,
} = {}) => {
  if (!action) return null;

  if (action === 'dismiss') {
    await dismiss?.();
    return { dismissed: true };
  }

  // 이동형 카드: 수락 기록은 fire-and-forget (실패해도 이동은 막지 않는다)
  if (action === 'open_batch') {
    Promise.resolve(act?.(action)).catch(() => {});
    if (typeof openBatch === 'function') {
      openBatch();
    } else {
      navigate?.(SAENGGIBU_BATCH_PATH);
    }
    return { opened: 'batch' };
  }

  if (action === 'open_upgrade') {
    Promise.resolve(act?.(action)).catch(() => {});
    navigate?.(SAENGGIBU_UPGRADE_PATH);
    return { opened: 'upgrade' };
  }

  // 서버 처리형 카드 (save_style_rule · save_example · enable_style · save_eval_plan_to_library):
  // accept 응답의 message 를 그대로 토스트한다. save_eval_plan_to_library 는 영속 원본을 자료함으로
  // 복제하고 "자료함에 저장했어요"(또는 이미 있으면 "이미 자료함에 있는 자료예요")를 준다.
  try {
    const data = await act?.(action, { option, text });
    // message 가 null(이동형)이면 토스트를 띄우지 않는다
    if (typeof data?.message === 'string' && data.message) {
      showToast?.(data.message, 'success');
    }
    return data || null;
  } catch (error) {
    // 400/403: 서버가 준 해요체 안내(detail). 그 외(네트워크·5xx 기본 메시지)는 일반 안내로 바꾼다.
    // 404 는 hook 이 카드를 접고 throw 하지 않으므로 여기 오지 않는다.
    const detail = typeof error?.detail === 'string' && error.detail.trim()
      ? error.detail.trim()
      : '';
    const status = Number(error?.status) || 0;
    const message = detail && (status === 400 || status === 403)
      ? detail
      : '제안을 적용하지 못했어요. 잠시 후 다시 시도해주세요';
    showToast?.(message, 'error');
    return null;
  }
};
